<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="layout-dialog"
      :show-close="false"
      title="予定日時設定"
      top="5vh"
      width="900px"
      :visible.sync="dialogVisible"
      append-to-body
      @close="close"
    >
      <div class="sure_box top_info mtn top_box">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">予定日時</vab-col>
          <vab-col :span="20" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{ dayTime }}
              </div>
            </div>
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="24" class="word_box" style="padding-top: 0px">
            <vab-calendar-span ref="calendar" />
          </vab-col>
        </vab-row>
      </div>
      <div slot="footer" class="dialog-footer flex_end mg12">
        <div class="flex_start flex_center_align">
          <vab-button :btn-list="btnList" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { calendarSure } from '@/api/rc/scheduleAdjConfirm'
  import { resetCalender, crossDaySet } from '@/utils/index'

  export default {
    name: 'FixedTime',
    provide() {
      return {
        vmData: this,
      }
    },
    props: {
      keyFlag: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialogVisible: false,
        btnList: [
          {
            name: 'キャンセル',
            type: 'button',
            hidden: false,
            click: () => {
              this.close()
            },
          },
          {
            name: '保存',
            icon: 'answer',
            type: 'button',
            hidden: false,
            click: () => {
              this.saveData()
            },
          },
        ],
        resetCalenderList: null,
        changeDate: {
          day: null,
          startTime: null,
          endTime: null,
        },
      }
    },
    computed: {
      dayTime() {
        const { day, startTime, endTime } = this.changeDate
        const dayFlag = day ? `${day}日` : ''
        let time = ''
        if (
          !this.$baseLodash.isNil(startTime) &&
          !this.$baseLodash.isNil(endTime)
        ) {
          time = `${startTime}〜${endTime}`
        }
        return `${dayFlag} ${time}`
      },
    },
    methods: {
      setParamsData(data) {
        this.paramsData = data
        this.dialogVisible = true
        this.setDayTime(data)
        this.calenderTime()
      },
      // 獲取日歴/暦数拠
      async calenderTime() {
        const params = {
          buildingCd: this.getFieldValue(
            'workingPlanAndResultIdModel.buildingCd',
            this.paramsData
          ),
          requestYearMonth: this.getFieldValue(
            'requestYearMonth',
            this.paramsData
          ),
          sectionCd: this.getFieldValue(
            'workingPlanAndResultIdModel.sectionCd',
            this.paramsData
          ),
        }
        const res = await calendarSure(params)
        if (res?.length && res?.length > 0) {
          let daysList = resetCalender.call(
            this,
            this.getDateList([this.paramsData]),
            res
          )
          this.resetCalenderList = crossDaySet(
            daysList,
            params.requestYearMonth
          )
          this.$nextTick(() => {
            this.$refs.calendar.getTimes(params.requestYearMonth).then(() => {
              this.$refs.calendar.setPageData(params)
              this.$refs.calendar.setCalenderTime(this.resetCalenderList, this)
            })
          })
        }
      },
      getDateList(list) {
        return list
      },
      // 関閉弾框
      close() {
        this.dialogVisible = false
        this.$refs.calendar.clearTimes()
      },
      setDayTime(data) {
        const { day, startTime, endTime } = data
        this.changeDate = {
          day: day,
          startTime: startTime,
          endTime: endTime,
        }
      },
      // 保存
      saveData() {
        this.$emit('saveData', this.changeDate)
        this.close()
      },
    },
  }
</script>
